// extracted by mini-css-extract-plugin
module.exports = {"matched":"matched___1f5Jt","matched-intent-text":"matched-intent-text___zPi_z","label":"label___3TXFU","hover":"hover___3XRpM","text":"text___9c2dG"};